import React from "react";
import { IconProps } from "./types";

interface AvatarIconProps extends IconProps {
  backgroundColor?: string;
  borderColor?: string;
  textColor?: string;
}

const AvatarIcon: React.FC<AvatarIconProps> = ({
  width = 36,
  height = 36,
  className,
  backgroundColor = "white",
  borderColor = "#DCE4E9",
  textColor = "#313131",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M18 0.5C27.665 0.5 35.5 8.33502 35.5 18C35.5 27.665 27.665 35.5 18 35.5C8.33502 35.5 0.5 27.665 0.5 18C0.5 8.33502 8.33502 0.5 18 0.5Z"
        fill={backgroundColor}
        stroke={borderColor}
      />
      <path
        d="M18.1334 17.0587C18.05 17.0503 17.95 17.0503 17.8584 17.0587C15.875 16.992 14.3 15.367 14.3 13.367C14.3 11.3253 15.95 9.66699 18 9.66699C20.0417 9.66699 21.7 11.3253 21.7 13.367C21.6917 15.367 20.1167 16.992 18.1334 17.0587Z"
        stroke={textColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.9666 20.133C11.9499 21.483 11.9499 23.683 13.9666 25.0247C16.2583 26.558 20.0166 26.558 22.3083 25.0247C24.3249 23.6747 24.3249 21.4747 22.3083 20.133C20.0249 18.608 16.2666 18.608 13.9666 20.133Z"
        stroke={textColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default AvatarIcon;
